// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"71a2ce03","239":"fc1a9d28","453":"bcb005c6","455":"5abcd92d"}[chunkId] + ".chunk.js";
};